module.exports = __webpack_public_path__ + "img/bt.72ce79a8.png";